import { Location, LocationListener, UnregisterCallback } from 'history';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useHistory } from 'react-router-dom';

const sendPageView: LocationListener = (location: Location): void => {
  const path = location.pathname + location.search;
  ReactGA.set({ path });
  ReactGA.pageview(path);
};

interface Props {
    children?: JSX.Element;
    trackingId?: string;
}
const GAListener = ({ children, trackingId }: Props): JSX.Element | null => {
  const history = useHistory();
  useEffect((): UnregisterCallback | undefined => {
    if (trackingId) {
      ReactGA.initialize(trackingId);
      sendPageView(history.location, 'REPLACE');
      return history.listen(sendPageView);
    } else {
      return undefined;
    }
  }, [history, trackingId]);

  return children || null;
};

export default GAListener;
